import React from "react";
import styled from "styled-components";
import { useTypedSelector } from "store";
import ParametersTable from "../../../components/ParametersTable/ParametersTable.component";
import Grid from "@mui/material/Unstable_Grid2";
import { H4 } from "components";
import StandardTagsButton from "../Macros/ActionButtons/StandardTagsButton.components";

export default function ProductLinePVAs() {
  const { getting } = useTypedSelector((state) => state.products);

  if (getting) return <></>;

  return (
    <ParametersWrapper>
      <Grid container columnSpacing={3}>
        <Grid xs={8} display="flex" justifyContent="left">
          <ParametersTable
            header={"Tags"}
            parameterType="tags"
            addRowButtonLabel="ADD TAG"
          />
        </Grid>
        <Grid container xs={4}>
          <Grid container direction="column" rowSpacing={2}>
            <Grid display="flex" justifyContent="center">
              <StyledH4>Actions</StyledH4>
            </Grid>
            <Grid display="flex" justifyContent="center">
              <StandardTagsButton />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ParametersWrapper>
  );
}

const ParametersWrapper = styled.div`
  padding: 0;
`;

const StyledH4 = styled(H4)`
  color: ${(props) => props.theme.colors.muttedHeadlines};
  font-weight: 700;
`;
